import { Pipe, PipeTransform } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';

@Pipe({
  name: 'capitalizeAll',
  standalone: false
})
export class CapitalizeAllPipe implements PipeTransform {

  transform(value: string): string {
    const str: string = isNullOrUndefined(value) ? '' : value.toLowerCase().split('-').join(' ').trim();
    return str.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
  }

}
